/*

MIT License

Copyright (c) 2022 FrameMuse

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

*/

export class UnreachableCodeError extends Error {
  constructor(details: unknown) {
    super("Unreachable code reached with these details: " + JSON.stringify(details))

    this.name = UnreachableCodeError.name
  }
}

export const NOT_FORM_FIELD_ELEMENT = "This target is not FormFieldElement (HTMLInputElement | HTMLTextAreaElement | RadioNodeList)."
